<template>
	<div class="row align-items-center menu">
		<div class="col-md-2"></div>
		<div class="col-md-2">
			<input type="button" value="Facturación" class="form-control" @click="accion('FACTURACION')">
		</div>
		<div class="col-md-2">
			<input type="button" value="Re-Facturación" class="form-control" @click="accion('REFACTURACION')">
		</div>
		<div class="col-md-2">
			<input type="button" value="DTE Manual" class="form-control" @click="accion('DTE MANUAL')">
		</div>
		<div class="col-md-2">
			<input type="button" value="Clientes" class="form-control" @click="accion('CLIENTES')">
		</div>
	</div>
</template>
<script lang="ts">

	export default 
	{
		name: "MenuPrincipal",
		props: {
			onMenu: Function, // Funcion callback para informar la opcion sobre la que se hizo click
		},
		methods: {

			accion(menu) 
			{
				if (this.onMenu)
					this.onMenu(menu)
			}
		},
	}
</script>
<style scoped>

	.menu {
		position: fixed;
		width: 100%;
		height: 100%;
		margin-right: 0 !important;
		margin-left: 0 !important;
		background-image: url("/images/fondo.jpg");
	}

	.menu input {
		height: 80px;
		font-size: 20px;
		border-radius: 10px;
		color: #6c757d;
		font-weight: 500;
		background: #dadada;
	}

	.menu input:hover {
		height: 80px;
		font-size: 22px;
		border-radius: 10px;
		color: white;
		font-weight: 500;
		background: #a9524a;
	}

</style>
